import ENV from '../../run-config';

const { brand } = ENV;

const defaults = {

};

let textElements;

if (brand === 'customerexpert') {
  textElements = {
    headerPreHeadline: 'Bundesgremium Baustoff-, Eisen- und Holzhandel',
    headerHeadlineLine1: 'Deine neue',
    headerHeadlineLine2: 'WissensApp',
    headerText: 'Die neue fachspezifische Wissens-App: Der customer EXPERT vermittelt dir umfangreiches Wissen im Baustoff-, Eisenwaren-, Haushaltswaren- und Holzhandel („building-, iron-, home- und wood STAR“) sowie in Wirtschaftskunde und kaufmännischem Rechnen.',
    bodyHeadline1: 'Der Weg zum',
    bodyHeadline2: 'customer EXPERT',
    bodyText: 'Wähle drei von vier STARS. Der customerEXPERT wird bei positivem Abschluss von drei der vier STARS verliehen.',
    companyName: 'Bundesgremium Baustoff-, Eisen- und Holzhandel',
    companyName2: 'c/o Wirtschaftskammer Österreich',
    companyAddress: 'Wiedner Hauptstrasse 63, A-1045 Wien',
    companyPhone: '+43 (0)5 90 900 - 3233',
    companyFax: '+43 (0)5 90 900 - 287',
    companyMail: 'customerexpert@wko.at',
    videoUrl: 'https://smorder.azureedge.net/app-assets/sla/customer_expert.mp4',
    folderUrl: 'https://smorder.azureedge.net/app-assets/sla/Folder Costumer Expert A5 BGR LO5.pdf',
    agbUrl: 'https://smorder.azureedge.net/app-assets/sla/AGBs_cE_final.pdf',
    imageSourceList: 'https://smorder.azureedge.net/app-assets/sla/Bildquellenverzeichnis_customerEXPERT_fin.pdf'
  };
} else if (brand === 'whitelabel') {
  textElements = {
    headerPreHeadline: 'Bundesgremium Baustoff-, Eisen- und Holzhandel',
    headerHeadlineLine1: 'Deine smarte',
    headerHeadlineLine2: 'Lehre!',
    headerText: 'Der customer EXPERT vermittelt dir umfangreiches Wissen im Baustoff-, Eisenwaren-, Haushaltswaren- und Holzhandel („building-, iron-, home- und wood STAR“) sowie in Wirtschaftskunde und kaufmännischem Rechnen.',
    bodyHeadline1: 'So wirst du zum',
    bodyHeadline2: 'customer EXPERT',
    bodyText: 'Wähle drei von vier Kursen. Der customer EXPERT wird bei positivem Abschluss von drei der vier Kurse verliehen. STARS sind die unterschiedlichen Kurse.',
    companyName: 'Bundesgremium Baustoff-, Eisen- und Holzhandel',
    companyName2: 'c/o Wirtschaftskammer Österreich',
    companyAddress: 'Wiedner Hauptstrasse 63, A-1045 Wien',
    companyPhone: '+43 (0)5 90 900 - 3233',
    companyFax: '+43 (0)5 90 900 - 287',
    companyMail: 'customerexpert@wko.at',
  };
}


export default(Object.assign({}, defaults, textElements));



// WEBPACK FOOTER //
// ./src/app/landingpage__new/langingpage-content.js